import { render, staticRenderFns } from "./changeWindNameModal.vue?vue&type=template&id=5e65a126"
import script from "./changeWindNameModal.vue?vue&type=script&lang=js"
export * from "./changeWindNameModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/apps/wpms/web/wind-plannerDev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e65a126')) {
      api.createRecord('5e65a126', component.options)
    } else {
      api.reload('5e65a126', component.options)
    }
    module.hot.accept("./changeWindNameModal.vue?vue&type=template&id=5e65a126", function () {
      api.rerender('5e65a126', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plan/components/changeWindNameModal.vue"
export default component.exports